// extracted by mini-css-extract-plugin
export var container = "files-to-download-module--container--ca9a1";
export var error = "files-to-download-module--error--ea707";
export var list = "files-to-download-module--list--857e3";
export var loader = "files-to-download-module--loader--c2ab2";
export var lowOpacity = "files-to-download-module--lowOpacity--bec15";
export var noContent = "files-to-download-module--no-content--71357";
export var paginationRow = "files-to-download-module--pagination-row--3d4e2";